import React from 'react';
import { AudioLines, FileOutput, FileVideo, Trash2 } from 'lucide-react';
import type { NodeData, WorkflowNode } from '../nodes/NodeTypes';
import NodeFields from './NodeFields';

interface NodeInspectorProps {
  node?: WorkflowNode;
  onChange: (nodeId: string, patch: Partial<NodeData>) => void;
  onDelete: (nodeId: string) => void;
}

const NodeInspector: React.FC<NodeInspectorProps> = ({ node, onChange, onDelete }) => {
  return (
    <aside className="node-inspector" aria-label="节点检查器">
      <div className="panel-heading">
        <div>
          <h2>属性</h2>
          <p>{node ? '编辑所选节点参数' : '选择画布中的节点'}</p>
        </div>
        {node && node.type === 'processing' && (
          <button type="button" className="icon-button icon-button--danger" onClick={() => onDelete(node.id)} title="删除节点" aria-label="删除节点">
            <Trash2 size={16} />
          </button>
        )}
      </div>
      {node ? (
        <div className="inspector-content">
          <div className="inspector-node-heading">
            <span className={'inspector-node-icon inspector-node-icon--' + (node.data.streamType || node.type)} aria-hidden="true">
              {node.type === 'input' ? <FileVideo size={17} /> : node.type === 'output' ? <FileOutput size={17} /> : node.data.streamType === 'audio' ? <AudioLines size={17} /> : <FileVideo size={17} />}
            </span>
            <div>
              <strong>{node.data.label}</strong>
              <span>{node.type === 'input' ? '输入源' : node.type === 'output' ? '输出目标' : node.data.category || (node.data.streamType === 'audio' ? '音频处理' : '视频处理')}</span>
            </div>
          </div>
          <NodeFields node={node} onChange={onChange} />
        </div>
      ) : (
        <div className="inspector-empty">
          <span className="inspector-empty__line" />
          <p>节点的文件路径、滤镜参数与编码设置会显示在这里。</p>
        </div>
      )}
    </aside>
  );
};

export default NodeInspector;
